export default __webpack_public_path__ + "static/media/play_black.7b49927c.svg";